import { getWidgetAttributes } from '@sportal365/smp-widget-utils';
import WidgetAttributes from '../../../../../packages/constants/widgetAttributes';
import { MULTISPORT_EVENTS } from '../../../../../packages/constants/widgetIds';

export const multisportEventsAttributes = getWidgetAttributes(
  MULTISPORT_EVENTS,
  // Required attributes:
  [WidgetAttributes.WIDGET_ID, WidgetAttributes.WIDGET_TYPE, WidgetAttributes.WIDGET_SPORT],
  // Optional attributes:
  [
    WidgetAttributes.THEME,
    WidgetAttributes.ENTITY_LINKS,
    WidgetAttributes.LABELS,
    WidgetAttributes.ODDS_BETTING_ID,
    WidgetAttributes.ODDS_DISPLAY,
    WidgetAttributes.ODDS_PRE_EVENT_ONLY,
    WidgetAttributes.AGE_RESTRICTION_DISPLAY,
    WidgetAttributes.OPTIONS_DISPLAY,
    WidgetAttributes.NAME_TYPE,
    WidgetAttributes.BETTING_LOGO_DISPLAY,
    WidgetAttributes.DATA_ODDS_CLICKABLE,
    WidgetAttributes.REFRESH_TIME,
    WidgetAttributes.DATA_SHOW_COMPETITION_NAMES,
    WidgetAttributes.DATE,
    WidgetAttributes.COMPETITIONS,
    WidgetAttributes.SPORT,
    WidgetAttributes.LIMIT,
  ],
);
